import { Button, Image } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

import type { Action, MainBannerV3BannerData, Pages } from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

type BannerImageProps = {
  banner?: MainBannerV3BannerData;
  isControlInactive: (control: Action) => boolean;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  isDraggingRef: React.RefObject<boolean>;
};

export const BannerImage: FC<BannerImageProps> = ({
  banner,
  isControlInactive,
  getUrl,
  onCallAction,
  isDraggingRef,
}) => {
  const { getDirectusImage } = useDirectus();

  const action = banner?.action;
  const isActionActive = action ? !isControlInactive(action) : false;
  const controlAction = action?.action?.[0]?.item;
  let href;

  if (isExternalLink(controlAction)) {
    href = controlAction.href ?? undefined;
  }
  if (isInternalLink(controlAction)) {
    href = controlAction.page ? getUrl(controlAction.page) : undefined;
  }
  const onPress = (): void => {
    if (isDraggingRef.current) {
      isDraggingRef.current = false;
      return;
    }
    if (action && isActionActive) {
      onCallAction(action);
    }
  };
  const img = banner?.image;

  const mImage = img?.image?.id ?? "";
  const mWidth = img?.mobile_image_width ?? undefined;
  const mHeight = img?.mobile_image_height ?? undefined;

  const mdImage = img?.tablet_image?.id ?? mImage;
  const mdWidth = img?.tablet_image_width ?? mWidth;
  const mdHeight = img?.tablet_image_height ?? mHeight;

  const dImage = img?.desktop_image?.id ?? mdImage;
  const dWidth = img?.desktop_image_width ?? mdWidth;
  const dHeight = img?.desktop_image_height ?? mdHeight;

  return (
    <Button
      href={isActionActive ? href : undefined}
      onPress={onPress}
      variant={"tertiary"}
      p={{ py: 0, px: 0 }}
      m={{ mx: "auto" }}
    >
      <Image
        value={getDirectusImage(mImage, {
          width: mWidth ? mWidth * 2 : undefined,
          height: mHeight ? mHeight * 2 : undefined,
          format: "webp",
          quality: 85,
        })}
        image={{
          alt: img?.alternative_text ?? "",
        }}
        mdValue={getDirectusImage(mdImage, {
          format: "webp",
          quality: 85,
          width: mdWidth ? mdWidth * 2 : undefined,
          height: mdHeight ? mdHeight * 2 : undefined,
        })}
        dValue={getDirectusImage(dImage, {
          format: "webp",
          quality: 85,
          width: dWidth ? dWidth * 2 : undefined,
          height: dHeight ? dHeight * 2 : undefined,
        })}
        maxWidth={"none"}
        maxHeight={"none"}
        d={{
          maxWidth: 1320,
        }}
      />
    </Button>
  );
};
